import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import PageLayout from "../components/pageLayout";
import { URL } from "../core/config.js"

const verificationStorageKey = (token) => `email-verification:${token}`;

const EmailVerificationContent = ({ token, navigateToLogin }) => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [allEmailsVerified, setAllEmailsVerified] = useState(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    const cached = sessionStorage.getItem(verificationStorageKey(token));
    if (cached) {
      const parsed = JSON.parse(cached);
      setStatus('success');
      setMessage(parsed.message);
      setAllEmailsVerified(parsed.allEmailsVerified);
      return;
    }

    let cancelled = false;

    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${URL}/users/verify-email/${token}`);
        if (cancelled) return;

        const successMessage = response.data.allEmailsVerified
          ? 'All emails verified! Your account is now pending approval.'
          : (response.data.message || 'Email verified successfully! Please also verify your other email address to complete registration.');

        sessionStorage.setItem(
          verificationStorageKey(token),
          JSON.stringify({
            message: successMessage,
            allEmailsVerified: Boolean(response.data.allEmailsVerified),
          })
        );

        setStatus('success');
        setAllEmailsVerified(Boolean(response.data.allEmailsVerified));
        setMessage(successMessage);

        if (response.data.allEmailsVerified) {
          setTimeout(() => navigateToLogin(), 4000);
        }
      } catch (error) {
        if (cancelled) return;
        setStatus('error');
        setMessage(
          error.response?.data?.error
          || 'Invalid verification link. If you already received a pending approval email, your verification is complete.'
        );
      }
    };

    verifyEmail();

    return () => {
      cancelled = true;
    };
  }, [token, navigateToLogin]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px', padding: '20px' }}>
      {status === 'loading' && (
        <div>
          <p><b>Verifying your email...</b></p>
        </div>
      )}
      
      {status === 'success' && (
        <div>
          <p style={{ color: 'green', fontSize: '18px' }}><b>✓ {message}</b></p>
          {!allEmailsVerified && (
            <div style={{ marginTop: '20px' }}>
              <p style={{ color: '#666' }}>
                Check your inbox for the other verification email.
              </p>
              <button 
                onClick={navigateToLogin}
                style={{
                  marginTop: '15px',
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      )}
      
      {status === 'error' && (
        <div>
          <p style={{ color: 'red', fontSize: '18px' }}><b>✗ {message}</b></p>
          <button 
            onClick={navigateToLogin}
            style={{
              marginTop: '15px',
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Go to Login
          </button>
        </div>
      )}
    </div>
  );
};

export default function EmailVerificationPage() {
  const params = useParams();
  const history = useHistory();

  const navigateToLogin = useCallback(() => history.push('/login'), [history]);

  return (
    <PageLayout>
      <EmailVerificationContent token={params.token} navigateToLogin={navigateToLogin} />
    </PageLayout>
  );
}
